export default __webpack_public_path__ + "static/media/fad-logo-tracktion.ac658c97.svg";